import { render } from "./FontPicker.vue?vue&type=template&id=e90fe50c&scoped=true"
import script from "./FontPicker.vue?vue&type=script&lang=js"
export * from "./FontPicker.vue?vue&type=script&lang=js"

import "./FontPicker.vue?vue&type=style&index=0&id=e90fe50c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90fe50c"]])

export default __exports__